import { render, staticRenderFns } from "./tvr_structure.vue?vue&type=template&id=77e9c081&scoped=true"
import script from "./tvr_structure.vue?vue&type=script&lang=js"
export * from "./tvr_structure.vue?vue&type=script&lang=js"
import style0 from "./tvr_structure.vue?vue&type=style&index=0&id=77e9c081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e9c081",
  null
  
)

export default component.exports